/**
 * Formats a cover-page date consistently. Backend `coverDate` values are
 * sometimes raw ISO timestamps and sometimes free text (e.g. "Fall 2026") —
 * parseable dates are reformatted to match the fallback date's style;
 * anything else is shown as-is.
 */
export const formatCoverDate = (
  coverDate?: string,
  fallbackSource?: string,
): string => {
  if (coverDate) {
    const parsed = new Date(coverDate);
    if (!isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    }
    return coverDate;
  }

  return new Date(fallbackSource || Date.now()).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
